import React, { useState, useEffect } from 'react';

const SetupScreen = ({ onStart, initialTeams }) => {
  const [totalRounds, setTotalRounds] = useState(10);
  const [teams, setTeams] = useState(initialTeams);
  const [subject, setSubject] = useState('Mathematics');
  const [customSubject, setCustomSubject] = useState('');
  const [topic, setTopic] = useState('Multiplication Tables');

  const handleInputChange = (index, field, value) => {
    const updatedTeams = [...teams];
    updatedTeams[index][field] = value;
    setTeams(updatedTeams);
  };

  const handleStart = () => {
    const finalSubject = subject === 'Other' ? customSubject : subject;
    const updatedTeams = teams.map(team => ({ ...team, subject: finalSubject, topic }));
    onStart(totalRounds, updatedTeams);
  };

  const getTopicOptions = () => {
    switch (subject) {
      case 'Mathematics':
        return ['Addition', 'Subtraction', 'Division', 'Algebra', 'Pre Algebra', 'Calculus', 'Multiplication Tables'];
      case 'Science':
        return ['Chemistry', 'Periodic Table'];
      case 'Video Games':
        return ['Fortnite', 'Minecraft'];
      case 'Social Studies':
        return ['US Politics', 'Geography', 'Continents'];
      case 'English':
        return ['Antonyms', 'Synonyms', 'Vocabulary', 'Grammar', 'Punctuation', 'Spelling', 'Reading', 'Writing'];
      case 'Telugu':
        return ['Reading', 'Dictation', 'Writing', 'Stories',"Acchulu", "Hallulu"];
      default:
        return [];
    }
  };

  useEffect(() => {
    switch (subject) {
      case 'Mathematics':
        setTopic('Multiplication Tables');
        break;
      case 'Video Games':
        setTopic('Fortnite');
        break;
      case 'Social Studies':
        setTopic('Geography');
        break;
      case 'Science':
        setTopic('Chemistry');
        break;
      case 'English':
        setTopic('Synonyms');
        break;
      case 'Telugu':
        setTopic('Reading');
        break;
      default:
        setTopic('');
    }
  }, [subject]);

  return (
    <div className="setup-screen">
      <h1>Setup Game</h1>
      <label>
        Total Rounds:
        <input
          type="number"
          value={totalRounds}
          onChange={(e) => setTotalRounds(Number(e.target.value))}
          min="1"
        />
      </label>
      <label>
        Subject:
        <select
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        >
          <option value="Mathematics">Mathematics</option>
          <option value="Science">Science</option>
          <option value="Video Games">Video Games</option>
          <option value="Social Studies">Social Studies</option>
          <option value="English">English</option>
          <option value="Telugu">Telugu</option>
          <option value="Other">Other</option>
        </select>
      </label>
      {subject === 'Other' && (
        <label>
          Custom Subject:
          <input
            type="text"
            value={customSubject}
            onChange={(e) => setCustomSubject(e.target.value)}
          />
        </label>
      )}
      <label>
        Topic:
        <select
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
        >
          <option value="">Select Topic</option>
          {getTopicOptions().map((option, index) => (
            <option key={index} value={option}>{option}</option>
          ))}
        </select>
      </label>
      {teams.map((team, index) => (
        <div key={index} className="team-setup">
          <h2>{team.name}</h2>
          <label>
            Kid Name:
            <input
              type="text"
              value={team.kidName}
              onChange={(e) => handleInputChange(index, 'kidName', e.target.value)}
            />
          </label>
          <label>
            Grade:
            <input
              type="text"
              value={team.grade}
              onChange={(e) => handleInputChange(index, 'grade', e.target.value)}
            />
          </label>
        </div>
      ))}
      <button onClick={handleStart} className="start-button">Start Game</button>
    </div>
  );
};

export default SetupScreen;